/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.inbox.updateSeen'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  seenAt: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  sections: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.string<{
      knownValues: ['reports', 'subjects', 'accountStatus']
    }>(),
    { minLength: 1 },
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  seenAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
